import React from 'react';

import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { SessionsTable } from '../../../../components/addSessions/SessionsTable';
import { filterSessions } from '../../../../components/addSessions/utils/calcSessions';
import { ClassContainer } from '../../ClassContainer';
import { StyledFieldset } from '../index.styles';
import { Date } from './Date';

const Container = styled('div')`
    margin-top: 1rem;
`;

const Dates: React.FC = () => {
    const { dateFields, addDefaultDate, sessions, excludeSession, excludedSessions, classGroups } =
        useContainer(ClassContainer);
    const { t } = useTranslation('calendar');

    const renderDateInputs = () => {
        if (dateFields.length > 0) {
            return dateFields.map((dateField, index) => {
                const isLastIndex = dateFields.length - 1 === index;

                return (
                    <Date
                        key={index}
                        index={index}
                        isLastIndex={isLastIndex}
                        classSessionGroupUuid={dateField.classSessionGroupUuid}
                        label={dateField.label}
                        classGroups={classGroups}
                        attendanceType={dateField.attendanceType}
                        selectedGroups={dateField.selectedGroups}
                    />
                );
            });
        }

        return (
            <Button variant="contained" onClick={addDefaultDate}>
                {t('add-class-dates')}
            </Button>
        );
    };
    const filteredSessions = filterSessions({ sessions, excludedSessions });

    return (
        <StyledFieldset>
            <Container>
                {renderDateInputs()}
                <SessionsTable sessions={filteredSessions} excludeSession={(index) => excludeSession(index)} />
            </Container>
        </StyledFieldset>
    );
};

export default Dates;
